import { db, jsonFileStorageRef } from '../firebaseDB'
import _ from 'lodash'

export function parseExport (nodeArray, linkArray, storyId) {
  Promise.all(nodeArray.map(node => fetchNodeData(node))).then(jsonArray => {
    jsonArray.forEach(node => {
      node.nextNodeID = -1
    })
    // find and make connection
    let link = linkArray.map(link => {
      return [link.from, link.to]
    })
    for (let i = 0; i < jsonArray.length; i++) {
      for (let j = 0; j < link.length; j++) {
        if (Number(jsonArray[i].nodeId) === Number(link[j][0])) {
          jsonArray[i].nextNodeID = Number(link[j][1])
        }
      }
    }
    jsonArray.forEach((node) => parseNode(node, linkArray))
    // jsonArray.sort((a, b) => a.nodeId - b.nodeId)

    // write json to firebase storage
    // the json file can be open and read via a link
    let set = {}
    set['mainStory'] = {
      nodes: jsonArray
    }
    let text = JSON.stringify(set, null, '  ')
    let message = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
    let timestamp = Math.floor(Date.now() / 1000) + '.json'
    jsonFileStorageRef.child(storyId + '/' + timestamp)
      .putString(message, 'data_url')
      .then((snapshot) => {
        console.log('uploaded a data_url json file')
      })
    let updates = {}
    updates[`stories/` + storyId + '/latest_export'] = timestamp
    db.ref().update(updates)
      .then(snapshot => {
        console.log('Now you can track you latest version of json file under stories collection')
      })
  })
}
// chatBotIdList is used for LogicNode next node
// if chatBotIdList is empty, LogicNode.nextNodeID = -1
// otherwise  LogicNode.nextNodeID = chatbot.nodeId
let chatBotIdList = []
let userList = []
let fetchNodeData = (node) => {
  if (node.category === 'Root') {
    return fetchRootData(node)
  } else if (node.category === 'Scene') {
    return fetchSceneData(node)
  } else if (node.category === 'User') {
    userList.push(node)
    return fetchUserData(node)
  } else if (node.category === 'Logic') {
    return fetchLogicData(node)
  } else if (node.category === 'Chatbot') {
    chatBotIdList.push(node.key)
    return fetchChatBotData(node)
  } else {
    console.log('No such type of node:' + node.text)
  }
}

let fetchRootData = (node) => {
  let newNode = {}
  newNode.nodeId = node.key
  newNode.nodeType = 'MasterNode'
  newNode.root = { root_analysis: 2, root_universal: 3 }
  newNode.worldScaleFactor = parseFloat(node.worldScaleFactor)
  return newNode
}

let fetchSceneData = (node) => {
  return db.ref('timelines').child(node.timelineId)
    .once('value')
    .then(snapshot => snapshot.val())
}

let fetchUserData = (node) => {
  let userNode = {}
  userNode.nodeId = node.key
  userNode.nodeType = node.category
  userNode.conditions = []
  if (node.selectedValues) {
    userNode.conditions = [...node.selectedValues]
  }
  return userNode
}

let fetchLogicData = (node) => {
  let logicNode = {}
  logicNode.nodeId = node.key
  logicNode.nodeType = node.category
  if (node.logicNodeType === 'Conditional' && node.selectedValues[1].value === 'Non-Verbal') {
    logicNode.logicType = 'Non-Verbal'
    return logicNode
  }
  if (node.logicNodeType === 'Touch') {
    logicNode.conditionType = node.logicNodeType
    logicNode.conditions = []
    logicNode.selectedValues = node.selectedValues
    return logicNode
  }
  logicNode.logicType = node.logicNodeType
  logicNode.conditionType = ''
  logicNode.conditions = []
  return logicNode
}

let fetchChatBotData = (node) => {
  let chatBotNode = {}
  chatBotNode.nodeId = node.key
  chatBotNode.service = 'Mitsuku'
  chatBotNode.nodeType = 'DialogueNode'
  chatBotNode.triggerLine = ''
  let numberOfCallsNode = node.selectedValues.find(value => value.key === 'numberOfCalls')
  chatBotNode.duration = Number(numberOfCallsNode.value)
  let characterValue = node.selectedValues.find(value => value.key === 'selectedCharacter')
  chatBotNode['character'] = {}
  chatBotNode.character.model = characterValue.value
  chatBotNode.character.name = characterValue.value
  chatBotNode.selectedValues = _.cloneDeep(node.selectedValues)
  return chatBotNode
}

// start parseNode
let parseNode = (node, linkArray) => {
  switch (node.nodeType) {
    case 'MasterNode':
      break
    case 'Scene':
      node.nodeType = 'SceneNode'
      parseScene(node)
      break
    case 'User':
      node.nodeType = 'UserNode'
      parseUser(node)
      break
    case 'Logic':
      node.nodeType = 'LogicNode'
      parseLogic(node, linkArray)
      break
    case 'DialogueNode':
      parseDialogueNode(node)
      break
    default:
      console.log('Parser is not updated in parseNode() for this node yet: ', node.nodeType)
  }
}
// end of parseNode

// start parseScence
let parseScene = (node) => {
  let endTime = []
  if (node.elements) {
    node.elements.forEach((element) => {
      delete element.assetUrl
      delete element.phase
      switch (element.type) {
        case 'Character':
          parseCharacter(element, endTime)
          break
        case 'Prop':
          parseProp(element, endTime)
          break
        case 'Sound':
          parseSound(element, endTime)
          break
        case 'Experience':
          parseExperience(element, endTime)
          break
        case 'Overlay':
          parseOverlay(element, endTime)
          break
        case 'Set Design':
          parseSetDesign(element, endTime)
          break
        default:
          console.log('Could not recognize the element in parseScene() yet', element.type)
      }
    })
    node['nodeElements'] = node.elements
    delete node.elements
  }
  // This is the startTime and endTime for Scene node, end time takes whatever the block ends at last
  node['startTime'] = 0
  node['endTime'] = 0
  if (endTime.length !== 0) {
    node['endTime'] = Math.max(...endTime)
  }
}

let parseSetDesign = (element, endTime) => {
  if (typeof element.value !== 'undefined') {
    delete element.value
  }
  element['setDesign'] = { 'name': element.name, 'startTime': element.startTime, 'endTime': element.endTime, 'elements': _.cloneDeep(element.elements) }
  element.setDesign.elements.forEach(prop => {
    delete prop.prop.description
    delete prop.prop.image
    delete prop.prop.meta_data
    delete prop.prop.service
    prop.prop['origin'] = { 'position': prop.prop.position, 'rotation': prop.prop.rotation }
    prop.prop['type'] = 'Prop'
    delete prop.prop.position
    delete prop.prop.rotation
    prop.prop['startTime'] = element.setDesign.startTime
    prop.prop['endTime'] = element.setDesign.endTime
  })
  endTime.push(element.setDesign.endTime)
  delete element.destination
  delete element.layer
  delete element.name
  delete element.startTime
  delete element.endTime
  delete element.origin
  delete element.type
  delete element.elements
}
let parseSound = (element, endTime) => {
  if (typeof element.value !== 'undefined') {
    delete element.value
  }
  delete element.destination
  delete element.layer
  delete element.origin
  delete element.type
  delete element.elements
  element['sound'] = {}
  element['sound'] = { ...element }
  if (!element.sound.volume) {
    element.sound.volume = 1
  }
  endTime.push(element.sound.endTime)
  delete element.name
  delete element.startTime
  delete element.endTime
  delete element.sound.sound
}
let parseCharacter = (element, endTime) => {
  // if (typeof element.value !== 'undefined') {
  //   delete element.value
  // }
  element['character'] = {}
  element['character'] = { ...element }
  element['elementType'] = 'character'
  endTime.push(element.character.endTime)
  element.character.model = element.character.value
  element.character.androidAssetBundle = element.character.Android
  element.character.iOSAssetBundle = element.character.iOS
  element.character.characterElements = element.character.elements
  if (element.character.characterElements) {
    element.character.characterElements.forEach(element => {
      if (element.animation) {
        element.elementType = 'animation'
        element.animation.id = element.id
        delete element.id
        element.animation.androidAssetBundle = element.animation.Android
        delete element.animation.Android
        element.animation.iOSAssetBundle = element.animation.iOS
        delete element.animation.iOS
        console.log(element.animation)
      }
      if (element.line) {
        element.elementType = 'textToSpeech'
        element.line.id = element.id
        delete element.id
        if (element.line.voiceName) {
          element.line.voiceName = element.line.voiceName.substring(0, element.line.voiceName.length - 4)
        }
        element.textToSpeech = element.line
        delete element.line
      }
    })
  }
  delete element.character.Android
  delete element.character.iOS
  delete element.character.elements
  delete element.character.value
  delete element.value
  delete element.character.character
  delete element.destination
  delete element.layer
  delete element.name
  delete element.startTime
  delete element.endTime
  delete element.origin
  delete element.id
  delete element.type
  delete element.elements
  delete element.character.destination
  delete element.iOS
  delete element.Android
}
let parseProp = (element, endTime) => {
  // if (typeof element.value !== 'undefined') {
  //   delete element.value
  // }
  element['prop'] = {}
  element['prop'] = { ...element }
  element['elementType'] = element.type
  endTime.push(element.prop.endTime)
  element.prop.model = element.prop.value
  delete element.prop.value
  delete element.value
  delete element.prop.prop
  delete element.destination
  delete element.layer
  delete element.name
  delete element.startTime
  delete element.endTime
  delete element.origin
  delete element.type
  delete element.elements
  delete element.prop.destination
}
let parseExperience = (element, endTime) => {
  if (typeof element.value !== 'undefined') {
    delete element.value
  }
  element['experience'] = { 'name': element.name, 'startTime': element.startTime, 'endTime': element.endTime }
  endTime.push(element.experience.endTime)
  element['elementType'] = element.type
  delete element.destination
  delete element.layer
  delete element.name
  delete element.startTime
  delete element.endTime
  delete element.origin
  delete element.type
  delete element.elements
}
let parseOverlay = (element, endTime) => {
  element['overlay'] = { 'name': element.name, 'startTime': element.startTime, 'endTime': element.endTime, 'text': element.value, 'origin': element.origin }
  endTime.push(element.overlay.endTime)
  element['elementType'] = element.type
  delete element.value
  delete element.destination
  delete element.layer
  delete element.name
  delete element.startTime
  delete element.endTime
  delete element.origin
  delete element.type
  delete element.elements
}
// end parseScene

// start parseUser
let parseUser = (node) => {
  let texts = []
  let elementContainsType = node.conditions.find(ele => ele.key === 'type')
  let type = elementContainsType.value
  switch (type) {
    case 'Verbal':
      node.conditions = parseVerbal(texts, node.conditions)
      break
    case 'Non-Verbal':
      node.conditions = parseNonVerbal(node.conditions)
      break
    default:
      console.log('Could not recognize ' + type + ' in parseUser()')
  }
}
let parseVerbal = (texts, conditions) => {
  let keywordsList = conditions.find(condition => condition.key === 'keywords')
  let keywords = keywordsList.value
  if (typeof keywords !== 'undefined') {
    keywords.forEach(keyword => {
      texts.push(keyword.value)
    })
  }
  conditions.push({ 'speech': texts })
  let newConditions = conditions.filter(condition => condition.speech)
  conditions = [...newConditions]
  return conditions
}
let parseNonVerbal = (conditions) => {
  let nonVerbalList = conditions.find(condition => condition.key === 'conditions')
  let nonVerbals = nonVerbalList.value
  nonVerbals.forEach(nonVerbal => {
    if (nonVerbal.visualItem === 'gender') {
      let visualContent = {}
      let visual = { 'name': nonVerbal.visualItem, 'type': nonVerbal.visualItemType, 'value': nonVerbal.selectionValue }
      visualContent = {'photo': visual}
      conditions.push(visualContent)
    } else if (nonVerbal.visualItem === 'age') {
      let visualContent = {}
      let visual = { 'name': nonVerbal.visualItem, 'type': nonVerbal.visualItemType, 'value': nonVerbal.scaleValue }
      visualContent = { 'photo': visual }
      conditions.push(visualContent)
    } else {
      let visualContent = {}
      let visual = { 'name': nonVerbal.visualItem, 'type': nonVerbal.visualItemType, 'value': nonVerbal.booleanValue }
      visualContent = { 'photo': visual }
      conditions.push(visualContent)
    }
  })
  let newConditions = conditions.filter(condition => condition.photo)
  conditions = [...newConditions]
  return conditions
}
// end parseUser
//
// let updateLogicNode = () => {
//   console.log(('update the logic node data structure'))
//   let logicNodes = []
//   logicNodes = this.diagramData.nodeDataArray.filter(node => node.category === 'Logic')
//   for (let i = 0; i < logicNodes.length; i++) {
//     let conditions = []
//     let cur = logicNodes[i]
//     let linksFrom
//     switch (cur.logicNodeType) {
//       case 'Specific':
//         cur['conditionType'] = 'Probability'
//         linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === cur.key)
//         for (let j = 0; j < linksFrom.length; j++) {
//           conditions.push({
//             'probability': linksFrom[j].text.substr(0, linksFrom[j].text.length - 1) / 100,
//             'nextNodeID': linksFrom[j].to
//           })
//         }
//         break
//       case 'Conditional':
//         if (cur.selectedValues[1].value !== 'Verbal') {
//           break
//         }
//         cur['conditionType'] = 'STT'
//         linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === cur.key)
//         for (let j = 0; j < linksFrom.length; j++) {
//           let child = this.diagram.model.nodeDataArray.find(nodeData => nodeData.key === linksFrom[j].to)
//           if (child.category === 'User' && child.selectedValues[0].value === 'Verbal') {
//             let speechPhrase = []
//             let similarities = []
//             for (let k = 0; k < child.selectedValues[1].value.length; k++) {
//               speechPhrase.push(child.selectedValues[1].value[k].value)
//               // use similarity api here
//             }
//             conditions.push({
//               speechPhrase,
//               similarities,
//               'nextNodeID': linksFrom[j].to
//             })
//           }
//         }
//         break
//     }
//     cur['conditions'] = conditions
//   }
// }
// start parseLogic
let parseLogic = (node, linkArray) => {
  let linksFromCurrentLogic
  switch (node.logicType) {
    case 'Specific':
      node.conditionType = 'Probability'
      node.conditions = []
      linksFromCurrentLogic = linkArray.filter(link => link.from === node.nodeId)
      linksFromCurrentLogic.forEach(link => {
        if (link.text) {
          node.conditions.push({ 'nextNodeID': link.to, 'chance': parseFloat(link.text) / 100 })
        } else {
          node.conditions.push({ 'nextNodeID': link.to })
        }
      })
      node.nextNodeID = -1
      break
    case 'Conditional':
      node.conditionType = 'STT'
      node.conditions = []
      linksFromCurrentLogic = linkArray.filter(link => link.from === node.nodeId)
      linksFromCurrentLogic.forEach(link => {
        let speechPhrase = []
        let next = userList.find(user => Number(user.key) === Number(link.to))
        // userList.forEach(node => {
        //   if (node.key === link.to) {
        //     next = node
        //   }
        // })
        if (next) {
          next.selectedValues[1].value.forEach(word => {
            speechPhrase.push(word.value)
          })
          let nextLink = linkArray.find(link => Number(link.from) === Number(next.key))
          node.conditions.push({
            'speechPhrase': speechPhrase,
            'nextNodeID': nextLink.to
          })
        }
      })
      break
  }
  if (node.conditionType && node.conditionType === 'Touch') {
    linksFromCurrentLogic = linkArray.filter(link => link.from === node.nodeId)
    let index = 0
    linksFromCurrentLogic.forEach(link => {
      let nextNode = userList.find(user => Number(user.key) === Number(link.to))
      if (nextNode) {
        let curInteraction = ''
        if (node.selectedValues[7].value[index] === 'Tap') {
          if (node.selectedValues[8].value[index] === 'Double Tap') {
            curInteraction = 'DoubleTap'
          } else {
            curInteraction = 'Tap'
          }
          // curInteraction = node.selectedValues[8].value[index]
        } else {
          curInteraction = node.selectedValues[7].value[index] + node.selectedValues[8].value[index]
        }
        let nextLink = linkArray.find(link => Number(link.from) === Number(nextNode.key))
        node.conditions.push({
          'touchType': node.selectedValues[6].value,
          'id': index,
          'objectId': nextNode.selectedValues[1].value[0].value,
          'interactionType': curInteraction,
          'nextNodeId': nextLink.to
        })
        index++
      }
    })
    node.selectedValues = []
    delete node.selectedValues
  }
}
// end parseLogic

// start parseDialogueNode(chatbot)
let parseDialogueNode = (node) => {
  node.character.origin = {}
  let positionElement = node.selectedValues.find(value => value.key === 'characterPosition')
  let rotationElement = node.selectedValues.find(value => value.key === 'characterRotation')
  let characterVoiceNameElement = node.selectedValues.find(value => value.key === 'characterVoice')
  let characterVoiceVolumeElement = node.selectedValues.find(value => value.key === 'characterVoiceVolume')
  // let characterAnimationElement = node.selectedValues.find(value => value.key === 'characterAnimation')
  node.character.origin.position = positionElement.value
  node.character.origin.rotation = rotationElement.value
  node.character.elements = []

  let lineContents = { 'voiceName': characterVoiceNameElement.value, 'voiceVolume': characterVoiceVolumeElement.value }
  let line = { 'line': lineContents }
  node.character.elements.push(line)

  // let animationContents = { 'name': characterAnimationElement.value }
  // let animation = { 'animation': animationContents }
  // node.character.elements.push(animation)
  delete node.selectedValues
}
// end parseDialogueNode(chatbot)



// WEBPACK FOOTER //
// ./src/data/export-parser.js